//Options related to MIS-survey Prevention section

const mosquitoRepellantsOptions = [
	{ option_text: "Coils", option_id: 35 },
	{
		option_text: "Sprays/Insecticides",
		option_id: 36,
	},
	{ option_text: "Creams", option_id: 37 },
	{
		option_text: "Electronic devices",
		option_id: 38,
	},
	{ option_text: "Others", option_id: 39 },
	{ option_text: "None", option_id: 40 },
];

const firstSeekMalariaTreatmentOptions = [
	{ option_text: "Government hospital", option_id: 41 },
	{
		option_text: "Private hospital/clinic",
		option_id: 42,
	},
	{ option_text: "NGO hospital", option_id: 43 },
	{ option_text: "Mobile clinic", option_id: 44 },
	{
		option_text: "Private doctor (no hospital visit)",
		option_id: 45,
	},
	{
		option_text: "Community Nurse/ Health worker (No hospital visit)",
		option_id: 46,
	},
	{ option_text: "Pharmacy", option_id: 47 },
	{
		option_text: "Local drug store/Chemist",
		option_id: 48,
	},
	{
		option_text: "Mobile drug seller",
		option_id: 49,
	},
	{
		option_text: "Traditional healer",
		option_id: 50,
	},
	{ option_text: "Religious healer", option_id: 51 },
];

const nearestHealthcareOptions = [
	{ option_text: "Less than 30 mins", option_id: 52 },
	{ option_text: "30 mins - 1 hour;", option_id: 53 },
	{ option_text: "More than 1 hour", option_id: 54 },
	{ option_text: "I don't know ", option_id: 55 },
];

const healthcareTransportCostOptions = [
	{ option_text: "Free", option_id: 56 },
	{ option_text: "N1 - N999", option_id: 57 },
	{ option_text: "N1,000 - N1,999 ", option_id: 58 },
	{ option_text: "N2,000 - N2,999", option_id: 59 },
	{ option_text: "N3,000 - N3,999", option_id: 60 },
	{ option_text: "N4,000 - N4,999", option_id: 61 },
	{ option_text: "N5,000 - N5,999", option_id: 62 },
	{ option_text: "N6,000 - N6,999", option_id: 63 },
	{ option_text: "N7000 - N7,999", option_id: 64 },
	{ option_text: "N8,000 - N8,999", option_id: 65 },
	{ option_text: "N9,000 - N9,999", option_id: 66 },
	{ option_text: "Above N10,000", option_id: 67 },
	{ option_text: "I don't know", option_id: 68 },
];

//Options related to MIS-survey Treatment section

const testCostOptions = [
	{ option_text: "Free", option_id: 75 },
	{ option_text: "N1 - N999", option_id: 76 },
	{ option_text: "N1,000 - N1,999", option_id: 77 },
	{ option_text: "N2000 - N2,999", option_id: 78 },
	{ option_text: "N3,000 - N3,999", option_id: 79 },
	{ option_text: "N4,000 - N4,999", option_id: 80 },
	{ option_text: "N5,000 - N5,999", option_id: 81 },
	{ option_text: "N6,000 - N6,999", option_id: 82 },
	{ option_text: "N7000 - N7,999;", option_id: 83 },
	{ option_text: "N8,000 - N8,999", option_id: 84 },
	{ option_text: "N9,000 - N9,999;", option_id: 85 },
	{ option_text: "N10,000 - N10,999", option_id: 86 },
	{
		option_text: "N11,000 - N11,999;",
		option_id: 87,
	},
	{ option_text: "N12,000 - N12,999", option_id: 88 },
	{ option_text: "N13,000 - N13,999", option_id: 89 },
	{ option_text: "N14,000 - N14,999", option_id: 90 },
	{ option_text: "Above N15,000", option_id: 91 },
	{ option_text: "I don't know", option_id: 92 },
];

const malariaDrugCostOptions = [
	{ option_text: "Free", option_id: 93 },
	{ option_text: "N1 - N999", option_id: 94 },
	{ option_text: "N1,000 - N1,999", option_id: 95 },
	{ option_text: "N2000 - N2,999", option_id: 96 },
	{ option_text: "N3,000 - N3,999", option_id: 97 },
	{ option_text: "N4,000 - N4,999", option_id: 98 },
	{ option_text: "N5,000 - N5,999", option_id: 99 },
	{ option_text: "N6,000 - N6,999", option_id: 100 },
	{ option_text: "N7000 - N7,999;", option_id: 101 },
	{ option_text: "N8,000 - N8,999", option_id: 102 },
	{ option_text: "N9,000 - N9,999;", option_id: 103 },
	{
		option_text: "N10,000 - N10,999",
		option_id: 104,
	},
	{
		option_text: "N11,000 - N11,999;",
		option_id: 105,
	},
	{
		option_text: "N12,000 - N12,999",
		option_id: 106,
	},
	{
		option_text: "N13,000 - N13,999",
		option_id: 107,
	},
	{
		option_text: "N14,000 - N14,999",
		option_id: 108,
	},
	{ option_text: "Above N15,000", option_id: 109 },
	{ option_text: "I don't know", option_id: 110 },
];

const lastDrugPurchaseTime = [
	{ option_text: "0 – 4 weeks ago,", option_id: 111 },
	{ option_text: "1 – 5 months ago", option_id: 112 },
	{
		option_text: "6 – 12 months ago,",
		option_id: 113,
	},
	{
		option_text: "Over one year ago",
		option_id: 114,
	},
	{ option_text: "I don’t know", option_id: 115 },
];

//Options related to MIS-survey Feedback section

const childrenReceivedSMCOptions = [
	{ option_text: "Yes", option_id: 122 },
	{
		option_text: "No and i have a child of 5 years or below",
		option_id: 123,
	},
	{
		option_text: "No, I do not have a child of 5 years or below",
		option_id: 124,
	},
	{
		option_text: "I don’t know what it is ",
		option_id: 125,
	},
];

const firstDoseOptions = [
	{ option_text: "Less than 12 months", option_id: 126 },
	{ option_text: "1 year; 2 years", option_id: 127 },
	{ option_text: "3 years", option_id: 128 },
	{ option_text: "4 years", option_id: 129 },
	{ option_text: "5 years", option_id: 130 },
	{ option_text: "above 5 years", option_id: 131 },
	{
		option_text: "I don't know about malaria vaccine ",
		option_id: 132,
	},
];

const childrenReceiveVaccineOptions = [
	{ option_text: "Yes", option_id: 133 },
	{
		option_text: "No and I have a child of 5 years or below",
		option_id: 134,
	},
	{
		option_text: " No, I do not have a child of 5 years or below",
		option_id: 135,
	},
	{
		option_text: "I don’t know what it is",
		option_id: 136,
	},
];


export {
	mosquitoRepellantsOptions,
	firstSeekMalariaTreatmentOptions,
	nearestHealthcareOptions,
	healthcareTransportCostOptions,
    testCostOptions,
    malariaDrugCostOptions,
    lastDrugPurchaseTime,
    childrenReceivedSMCOptions,
    firstDoseOptions,
    childrenReceiveVaccineOptions
};
